import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { useUserTrialDetails } from '@revelio/auth';

import { MenuItemWithDisabledReason } from '../../../../shared/ui/menu-item/MenuItemWithDisabledReason';
import { usePageExport } from '../Chart/chart-menu/PageExportProvider';
import { getFileName } from '../Chart/utils/getFileName';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { PageType } from '../PageConfigProvider/types';

export const DataExportMenuItem = () => {
  const { exportAllChartsData } = usePageExport();
  const { config: pageConfig } = usePageConfig();
  const { config: tabContent } = useTabContentConfig();
  const { isTrialUser } = useUserTrialDetails<boolean>();

  const defaultFileName = getFileName({
    primaryFilterId: tabContent.primaryFilter?.id,
    pageName: pageConfig.name,
  });

  const handleExportAllChartsData = () => {
    try {
      exportAllChartsData(defaultFileName || 'report-data');
    } catch (error) {
      console.error('Error exporting all charts data:', error);
    }
  };

  const isMenuItemVisible = pageConfig.type === PageType.REPORT;

  if (!isMenuItemVisible) {
    return null;
  }

  return (
    <MenuItemWithDisabledReason
      onClick={handleExportAllChartsData}
      isDisabled={isTrialUser}
      disabledReason="Available on paid plans"
      icon={<IconArrowInbox size={16} />}
    >
      Download Data
    </MenuItemWithDisabledReason>
  );
};
